import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6 9V6H9V9H6ZM4 5C4 4.44772 4.44772 4 5 4H10C10.5523 4 11 4.44772 11 5V10C11 10.5523 10.5523 11 10 11H5C4.44772 11 4 10.5523 4 10V5ZM15 9V6H18V9H15ZM13 5C13 4.44772 13.4477 4 14 4H19C19.5523 4 20 4.44772 20 5V10C20 10.5523 19.5523 11 19 11H14C13.4477 11 13 10.5523 13 10V5ZM6 15V18H9V15H6ZM5 13C4.44772 13 4 13.4477 4 14V19C4 19.5523 4.44772 20 5 20H10C10.5523 20 11 19.5523 11 19V14C11 13.4477 10.5523 13 10 13H5ZM15 18V15H18V18H15ZM13 14C13 13.4477 13.4477 13 14 13H19C19.5523 13 20 13.4477 20 14V19C20 19.5523 19.5523 20 19 20H14C13.4477 20 13 19.5523 13 19V14Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 4H6V6H4V4ZM3 4C3 3.44772 3.44772 3 4 3H6C6.55228 3 7 3.44772 7 4V6C7 6.55228 6.55228 7 6 7H4C3.44772 7 3 6.55228 3 6V4ZM4 10H6V12H4V10ZM3 10C3 9.44772 3.44772 9 4 9H6C6.55228 9 7 9.44772 7 10V12C7 12.5523 6.55228 13 6 13H4C3.44772 13 3 12.5523 3 12V10ZM12 4H10V6H12V4ZM10 3C9.44772 3 9 3.44772 9 4V6C9 6.55228 9.44772 7 10 7H12C12.5523 7 13 6.55228 13 6V4C13 3.44772 12.5523 3 12 3H10ZM10 10H12V12H10V10ZM9 10C9 9.44772 9.44772 9 10 9H12C12.5523 9 13 9.44772 13 10V12C13 12.5523 12.5523 13 12 13H10C9.44772 13 9 12.5523 9 12V10Z"
  />
);

export const AppsIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Apps" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
